import type { MigrationStrategies } from "./_types/migration-strategies";

export const EPOCUS_REVIEW_MIGRATION_STRATEGIES: MigrationStrategies = {
  1: (oldDoc) => oldDoc,
  2: (oldDoc) => ({ ...oldDoc, signedAt: null }),
  3: ({ originalFindings, revisedFindings, ...rest }) => ({
    ...rest,
    imageQualityScore: null,
  }),
};
